// extracted by mini-css-extract-plugin
export var rateTable = "_4z-0";